import React, { CSSProperties, FunctionComponent, ImgHTMLAttributes, useEffect } from 'react';
import { CheckButton, CheckLabel, CheckSubText, CheckText, IconContainer } from './CheckItem.style';

interface Props {
  ariaLabel?: string;
  containerStyle?: CSSProperties;
  label: string;
  subLabel?: string;
  checked: boolean;
  checkedIcon?: ImgHTMLAttributes<any>;
  unCheckedIcon?: ImgHTMLAttributes<any>;
  onValueChange: (value: boolean) => void;
  testID?: string;
}

const CheckItem: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    if (props.checkedIcon && props.checkedIcon.src) {
      // Preload checked icon to prevent flickering
      const img = new Image();
      img.src = props.checkedIcon.src;
    }
  }, [props.checkedIcon]);

  return (
    <CheckButton
      aria-label={props.ariaLabel}
      checked={props.checked}
      style={props.containerStyle}
      onClick={() => props.onValueChange(!props.checked)}
      role="checkbox"
      type="button"
      aria-checked={props.checked}
      data-testid={props.testID}
    >
      {props.checked && !!props.checkedIcon && (
        <IconContainer>
          <img
            src={props.checkedIcon.src}
            width={props.checkedIcon.width}
            height={props.checkedIcon.height}
            alt="checked icon"
            data-testid="checked-icon"
          />
        </IconContainer>
      )}

      {!props.checked && !!props.unCheckedIcon && (
        <IconContainer>
          <img
            src={props.unCheckedIcon.src}
            width={props.unCheckedIcon.width}
            height={props.unCheckedIcon.height}
            alt="unchecked icon"
            data-testid="unchecked-icon"
          />
        </IconContainer>
      )}

      <CheckLabel checked={props.checked}>
        <CheckText checked={props.checked}>{props.label}</CheckText>

        {props.subLabel && <CheckSubText checked={props.checked}>{props.subLabel}</CheckSubText>}
      </CheckLabel>
    </CheckButton>
  );
};

export default React.memo(CheckItem);
